/**
 * Created by root on 8/28/16.
 */
define(function (require) {

    var BaseTableWidgetsManager = require('web-agent-framework/BaseTableWidgetsManager');

    var ConnectionsLogListWidgetsManager = BaseTableWidgetsManager.extend({
        ControllerName:  'ConnectionsLogTableViewController',
        applicationType: 'ConnectionsLogTableViewController'
    });

    return ConnectionsLogListWidgetsManager;

});
